import { render, staticRenderFns } from "./SurveyBuilderSurvey.vue?vue&type=template&id=195076e5&scoped=true"
import script from "./SurveyBuilderSurvey.vue?vue&type=script&lang=js"
export * from "./SurveyBuilderSurvey.vue?vue&type=script&lang=js"
import style0 from "./SurveyBuilderSurvey.vue?vue&type=style&index=0&id=195076e5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195076e5",
  null
  
)

export default component.exports